import React, {useEffect, useState} from "react";
import {MultiSelect} from "primereact/multiselect";


const DCTagsFilter = ({dataCollectionsList, filterDataCollections, TagsList, initialTags, onChange, status}) => {

    const [selectedTag, setSelectedTag] = useState(initialTags);

    const onFilter = (e) => {
        setSelectedTag(e.value);
        onChange(e.value,status);
    };

    return <MultiSelect value={selectedTag} options={TagsList}
                        onChange={onFilter}
                        optionLabel="name" placeholder="Select a tag" className="p-column-filter"/>;

}

export default DCTagsFilter;
